import { useLocation } from 'react-router-dom';
import { CookieConsent } from '../common';
import HeaderFragment from './HeaderFragment';
import FooterFragment from './FooterFragment';
import LoginAsUserBanner from './LoginAsUserBanner';

// Routes that should render without Header/Footer (full-page/chromeless mode)
const CHROMELESS_ROUTES = ['/app/site-builder'];

// Component to handle conditional layout based on route
const AppLayout = ({ children }) => {
    const location = useLocation();
    const isChromeless = CHROMELESS_ROUTES.some(route =>
        location.pathname.startsWith(route)
    );

    if (isChromeless) {
        // Chromeless mode - no header/footer, full viewport
        return (
            <div className="min-h-screen bg-white dark:bg-neutral-900">
                {children}
            </div>
        );
    }

    // Normal mode - with header and footer
    return (
        <div className="flex flex-col min-h-screen bg-white dark:bg-neutral-900">
            <CookieConsent />
            <HeaderFragment />
            <LoginAsUserBanner />
            <main className="w-full main-gradient-bg flex-grow pt-20 sm:pt-24">
                {children}
            </main>
            <FooterFragment />
        </div>
    );
};

export default AppLayout;
